<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="
            $t.__(
                'activities.listing.massActions.ActivitiesListingMassDelete.delete_activities_title',
            )
        "
        @closed="$emit('close')"
        :primaryAction="{
            type: 'primary-destructive',
            label: $t.__('common.actions.confirm_and_delete'),
            action: () => confirmMassDelete(),
            loading: isSubmitting,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                action: () => {
                    $emit('close');
                },
            },
        ]"
    >
        <template slot="default">
            <span class="typographies-paragraph-medium-regular">
                {{ textContent }}
            </span>
        </template>
    </CompassDialog>
</template>
<script>
import { massDelete } from 'api/activities/activitiesMassActionsService';

export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        onError: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showModal: true,
            isSubmitting: false,
        };
    },
    computed: {
        textContent() {
            return this.$l10n.n__(
                'Êtes-vous sûr de vouloir supprimer cette activité ?',
                'Êtes-vous sûr de vouloir supprimer ces %d activités ?',
                this.selectedActivities.length,
                this.selectedActivities.length,
            );
        },
    },
    methods: {
        async confirmMassDelete() {
            try {
                this.isSubmitting = true;
                await massDelete(this.selectedActivities);
                this.$emit('close');
                this.onSuccess();
            } catch (error) {
                this.onError(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
